export default class NotificationBar {
    constructor(name, value, days = 30) {
        // Store different values to make cookie. We'll assume it's only for current domain and at root path
        this.name       = name, // Cookie Name (aka the key)
        this.value      = value, // Cookie Value
        this.expires    = days, // Defaults to 30 days

        this.notificationBtn        = document.getElementById("notificationBtn"), // Close Button ID
        this.notificationContainer  = document.getElementById("notificationContainer"); // Notification Container

        this.init();
    }

    init() {
        this.runNotificationCheck();
    }

    set() {
        let expire = new Date();
        expire.setTime(expire.getTime() + (this.expires * 24 * 60 * 60 * 1000)); // Use the this.expires to get date in future of cookie expiration.

        let expireString = "expires=" + expire.toUTCString();

        // Create Cookie
        document.cookie = this.name + "=" + this.value + ";" + expireString + ";path=/";
    }
    
    get() {
        let name = this.name + "=";
        let cookieArray = document.cookie.split(";");

        for(let i = 0; i < cookieArray.length; i++) {
            let cookie = cookieArray[i];

            while (cookie.charAt(0) == " ") {
                cookie = cookie.substring(1);
            }

            // Return value of cookie name
            if (cookie.indexOf(name) == 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }   
        return false;
    }

    addClassAccepted() {
        // Visual Studio freaks out on bang bang or (!!). We're checking for truthiness. Basically it's something but not null, empty, or false.
        if (!!this.notificationContainer) { 
            this.notificationContainer.classList.add(this.value);
        }
    }

    removeClassAccepted() {
        if (!!this.notificationContainer) {
            this.notificationContainer.classList.remove(this.value);
        }
    }

    createCookie() {
        this.set();
    }

    runNotificationCheck() {
        let self = this;
    
        if (this.get() && this.get() != false && this.get() == this.value) {
            // Means user has already seen message and accepted. So hide message by adding class .accepted. | Do other Accepted methods
            this.addClassAccepted();
        } else {
            // By default container already starts off with class accepted and is hidden to users. By adding a setTimeout and remove class .accepted the notificationBar this will pop in and get the users attention.
            setTimeout(function () {
                self.removeClassAccepted();
            }, 250);

            // This checks if button exists then add event listener on click
            if (!!this.notificationBtn) {
                this.notificationBtn.addEventListener("click", function () {
                    // Set button to have listener. Perform following functions if clicked.
                    self.addClassAccepted();
                    self.createCookie();
                });
            }
            // If Cookie is not set. Means user has not closed notification bar.
        }
    }
}
